<script setup lang="ts">
</script>
<template>
  <section>
    <div class="mx-auto xl:h-[500px] lg:h-[350px] max-sm:h-[max-content] overflow-hidden relative flex justify-center items-center">
      <div class="intro flex flex-col items-center text-center px-4">
        <h1 class="text-white text-base md:text-2xl lg:text-5xl font-bold mb-3 max-lg:mt-5 text-nowrap"><span class="bg-gray-800 bg-opacity-75 px-2 py-3 lg:px-5 lg:py-6">Video- und Fotografie aus Bad Segeberg</span></h1>
        <p class="mb-6 md:w-1/3 font-semibold -rotate-3 max-md:text-sm lg:text-xl"><span class="bg-pink-500 text-white tracking-wide">Professionelle Foto- und Videografie von Axel Schaffrath aus Bad Segeberg – für Unternehmen, Events und besondere Momente.</span></p>
        <!--      <slot name="intro"/>-->
      </div>
      <video width="100%" height="350px" autoplay playsinline muted loop preload="auto" class="absolute left-0 top-[50%] translate-y-[-50%] right-0 z-[-1]" >
        <source src="https://z3prodeqbezczbcr.public.blob.vercel-storage.com/studio/videos/HafenCity%20DJ%20Action.mp4"  type="video/mp4" />
      </video>
    </div>
    <figure v-if="$slots.images">
      <slot name="images" mdc-unwrap="p" />
    </figure>
  </section>
  <section class="px-4">
    <div class="container max-w-screen-lg mx-auto my-12">
      <h2 class="lg:text-2xl font-bold leading-tight text-gray-800">
        Dein Moment. Mein Blick.
      </h2>
      <p class="pb-3 max-md:text-sm">
        Jeder Augenblick erzählt eine Geschichte – aber nicht jeder Augenblick wird festgehalten. Als freiberuflicher Video- und Fotograf aus Bad Segeberg ist es meine Leidenschaft, genau diese flüchtigen Momente einzufangen und sie in bleibende Bilder und Filme zu verwandeln – egal ob als klassisches Foto, cineastischer Image-Film oder knackiger Reel für Instagram.
      </p>
      <p class="max-md:text-sm">Ob das Strahlen auf den Gesichtern deines Teams beim Firmenjubiläum, die Energie eines Live-Events oder die stille Eleganz eines Produkts – ich sorge dafür, dass das, was dich bewegt, auch andere bewegt.
      </p>
    </div>
  </section>
  <section class="px-4 py-6 bg-gray-100">
    <div class="container mx-auto my-12">
      <div class="w-auto md:w-3/4 lg:w-2/4 mx-auto bg-gray-800 text-white px-6 py-7 text-center cursor-pointer hover:bg-pink-600 transition">
        <h2 class="lg:text-2xl font-bold leading-tight text-pink-500 mb-4 block cursor-pointer hover:text-gray-800 transition z-10">
          Bereit für Bilder und Videos, die bleiben?
        </h2>
        <p class="font-semibold max-md:text-sm lg:text-xl">
          Lass uns reden. Ich freue mich darauf, dein Projekt kennenzulernen und gemeinsam herauszufinden, wie wir es am besten in Szene setzen – auf jedem Kanal, in jedem Format.
        </p>
        <div class="mt-6 text-center">
          <a href="mailto:info@axel-schaffrath.de" class="block">info@axel-schaffrath.de</a>
          <a href="tel:+4917645634961" class="block">0176 45634961</a>
        </div>
      </div>
    </div>
  </section>
</template>
<script setup lang="ts">
const { color } = defineProps({
  color: {
    type: String,
    default: 'orange'
  }
})
</script>

<style lang="scss" scoped>

</style>